module.exports = __webpack_public_path__ + "img/printbutton-gray.74efb4fa.svg";